<template>
  <div class="foot-page">
    <div class="foot-container">
      <div class="more-info-container">
        <div class="more-left-info-container" style="    position: relative;
    bottom: 25px;">
          <div class="logo">
            <img src="../assets/img/common/logo_foot.png" alt="" style="    height: 25px;
    width: auto;">
          </div>
          <div class="contact-info">
            <img src="../assets/img/common/contact2.png" alt="">
          </div>
        </div>
        <div class="more-other-info-container" v-if="shownav">
          <ul class="more-otherInfo-list-container" >
            <div class="more-otherInfo-title-container">
              <span>
                专家级服务
              </span>
            </div>
            <li class="more-otherInfo-item-container" @click="jump( 'contactUs' )">
              <a href="javascript:;">
                乡镇村数字乡村发展规划   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'contactUs' )">
              <a href="javascript:;">
                特色产业园综合设计方案   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'contactUs' )">
              <a href="javascript:;">
                区域数字治理方案   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'contactUs' )">
              <a href="javascript:;">
                人工智能种植养殖建设方案   
              </a>
            </li>
          </ul>
          <ul class="more-otherInfo-list-container">
            <div class="more-otherInfo-title-container">
              <span>
                热门产品
              </span>
            </div>
            <li class="more-otherInfo-item-container">
              <a href="javascript:;" @click="jump( 'hardwareList' , 1 )">
                智联网关      
              </a>
            </li>
            <li class="more-otherInfo-item-container">
              <a href="javascript:;" @click="jump( 'hardwareList' , 2 )">
                农业传感器   
              </a>
            </li>
             <li class="more-otherInfo-item-container">
              <a href="javascript:;" @click="jump( 'hardwareDetails' , 156 )">
                高性价比多合一气象站   
              </a>
            </li>
             <li class="more-otherInfo-item-container">
              <a href="javascript:;" @click="jump( 'hardwareDetails' , 155 )">
                百倍云水肥一体化   
              </a>
            </li>
    
          </ul>
          <ul class="more-otherInfo-list-container">
            <div class="more-otherInfo-title-container">
              <span>
                特色行业
              </span>
            </div>
            <li class="more-otherInfo-item-container" @click="jump( 'intelligentAgricultureall' )">
              <a href="javascript:;">
                大棚人工智能种植    
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'digitalFishery' )">
              <a href="javascript:;">
                室内全自动种植养殖产品   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'digitalFishery' )">
              <a href="javascript:;">
                数字渔场   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'intelligentAgriculture' )">
              <a href="javascript:;">
                大田农业   
              </a>
            </li>
           
           
          </ul>
          <ul class="more-otherInfo-list-container">
            <div class="more-otherInfo-title-container">
              <span>
                关于我们
              </span>
            </div>
            <li class="more-otherInfo-item-container">
              <a href="javascript:;" @click="jump( 'joinUs' )">
                加入我们    
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'aboutUs' )">
              <a href="javascript:;">
                公司简介   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'aboutUs' )">
              <a href="javascript:;">
                合作伙伴   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'contactUs' )">
              <a href="javascript:;">
                联系我们   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'aboutUs' )">
              <a href="javascript:;">
                服务条款   
              </a>
            </li>
          </ul>
        </div>
        <div class="more-other-info-container" v-else>    
          <ul class="more-otherInfo-list-container" style="margin-left: 115px;">
            <div class="more-otherInfo-title-container">
              <span>
                热门产品
              </span>
            </div>
            <li class="more-otherInfo-item-container">
              <a href="javascript:;" @click="jump( 'hardwareList' , 1 )">
                智联网关      
              </a>
            </li>
            <li class="more-otherInfo-item-container">
              <a href="javascript:;" @click="jump( 'hardwareList' , 2 )">
                农业传感器   
              </a>
            </li>
             <li class="more-otherInfo-item-container">
              <a href="javascript:;" @click="jump( 'hardwareDetails' , 156 )">
                高性价比多合一气象站   
              </a>
            </li>
             <li class="more-otherInfo-item-container">
              <a href="javascript:;" @click="jump( 'hardwareDetails' , 155 )">
                百倍云水肥一体化   
              </a>
            </li>
    
          </ul>
          <ul class="more-otherInfo-list-container" style="margin-left: 115px;">
            <div class="more-otherInfo-title-container">
              <span>
                特色行业
              </span>
            </div>
            <li class="more-otherInfo-item-container" @click="jump( 'intelligentAgricultureall' )">
              <a href="javascript:;">
                大棚人工智能种植    
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'digitalFishery' )">
              <a href="javascript:;">
                室内全自动种植养殖产品   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'digitalFishery' )">
              <a href="javascript:;">
                数字渔场   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'intelligentAgriculture' )">
              <a href="javascript:;">
                大田农业   
              </a>
            </li>
           
           
          </ul>
          <ul class="more-otherInfo-list-container" style="margin-left: 115px;">
            <div class="more-otherInfo-title-container">
              <span>
                关于我们
              </span>
            </div>
            <li class="more-otherInfo-item-container">
              <a href="javascript:;" @click="jump( 'joinUs' )">
                加入我们    
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'aboutUs' )">
              <a href="javascript:;">
                公司简介   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'aboutUs' )">
              <a href="javascript:;">
                合作伙伴   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'contactUs' )">
              <a href="javascript:;">
                联系我们   
              </a>
            </li>
            <li class="more-otherInfo-item-container" @click="jump( 'aboutUs' )">
              <a href="javascript:;">
                服务条款   
              </a>
            </li>
          </ul>
        </div>
        <div class="more-right-info-container">
          <div class="more-right-info-title">
            关注我们
          </div>
          <div class="erweima">
            <img src="../assets/img/common/erweima.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="copyright-info-container">
      <span>
        {{title1}}
      </span>
      <a class="text" title="" href="https://beian.miit.gov.cn" target="_Blank" style="color: #5e5c60;">{{title2}}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'foot',
  data(){
    return {
      shownav:false,
       title1:"",
       title2:"",
    }
  },
  mounted() {
    this.changetitle()
  },
  methods: {
    changetitle(){//http://www.100byun.com  http://100byun.com使用这个域名访问官网时，底部的备案信息需要更换下，其它访问方式时，底部备案信息还是跟当前一样不变
      var url = window.location.href
      this.shownav = true
      if(url.split("/#/")[0] == "http://www.100byun.com"||url.split("/#/")[0] == "http://100byun.com"){
        this.title1 = "杭州百倍云科技有限公司  @2014.all rights reserved."
        this.title2 = "浙ICP备15005770号-1"
         //this.shownav = false
      }else{
        this.title1 = "百倍云（浙江）物联科技有限公司版权所有 @2014.all rights reserved." 
        this.title2 = "浙ICP备2020040043号"
        // this.shownav = true
         
      }
      

    },
    jump( pathName , id ){
      if( id ){
        this.$router.push({
          name: pathName,
          query: {
            id: id,
          }
        })
      }else{
        this.$router.push({
          name: pathName,
        })
      }
    },
    jumpParams( pathName , id ){ // 使用 params 传值
      if( id ){
        this.$router.push({
          name: pathName,
          params: {
            id: id,
          }
        })
      }else{
        this.$router.push({
          name: pathName,
        })
      }
    },
  }
}
</script>

<style lang="scss" scope>
</style>
